<template>
  <v-form ref="form" v-model="valid" @submit.prevent="submit">
    <v-card>
      <v-alert type="error" v-if="errors.non_field_errors">
        <p v-for="error in errors.non_field_errors" :key="error">
          {{ error }}
        </p>
      </v-alert>
      <v-card-title>
        <SubTitle>Join fretshare</SubTitle>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <!--v-col cols="12" sm="6">
              <v-text-field
                v-model="name"
                label="Name*"
                name="name"
                prepend-icon="mdi-account-circle"
                required
              ></v-text-field>
            </v-col-->
            <v-col cols="12">
              <v-text-field
                v-model="email"
                label="Email*"
                name="email"
                type="email"
                prepend-icon="mdi-email"
                required
                @change="resetValidation"
                :rules="rulesEmail"
                :error="errors.email !== undefined"
                :error-messages="errors.email"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="password1"
                label="Password*"
                name="password1"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                required
                :rules="rulesPassword"
                :error="errors.password1 !== undefined"
                :error-messages="errors.password1"
                @change="resetValidation"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="password2"
                label="Re-enter Password*"
                name="password2"
                :type="showPassword ? 'text' : 'password'"
                prepend-icon="mdi-lock"
                :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                required
                :rules="rulesPassword"
                :error="errors.password2 != undefined"
                :error-messages="errors.password2"
                @change="resetValidation"
                @click:append="showPassword = !showPassword"
              ></v-text-field>
            </v-col>
            <!-- v-col cols="12">
              <v-autocomplete
                :items="[
                  'Guitar',
                  'Bass',
                  'Mandolin',
                  'Ukelele',
                  '7-String Guitar'
                ]"
                label="Instruments"
                prepend-icon="mdi-guitar-acoustic"
                multiple
                hint="don't be shy, even if you're just starting"
                persistent-hint
              ></v-autocomplete>
            </v-col -->
            <!--v-col cols="12">
              <v-menu
                v-model="showPicker"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="birthday"
                    label="Date of Birth"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="birthday"
                  @input="showPicker = false"
                ></v-date-picker>
              </v-menu>
            </v-col-->
          </v-row>
        </v-container>
        <small>* indicates required field</small>
      </v-card-text>
      <v-card-actions>
        <v-btn color="error" class="mx-auto" text @click="close">Cancel</v-btn>
        <v-btn
          type="submit"
          color="success"
          class="mx-auto"
          :loading="submitting"
          :disabled="!valid"
          >Join</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import { mapActions } from "vuex";

const NO_ERRORS = {};

export default {
  name: "RegisterForm",
  data: () => ({
    errors: NO_ERRORS,
    // name: null,
    email: null,
    password1: null,
    password2: null,
    showPassword: false,
    valid: false,
    submitting: false,
    birthday: new Date().toISOString().substr(0, 10),
    rulesEmail: [value => !!value || "Must not be empty"],
    rulesPassword: [
      value => (value && value.length >= 4) || "Minimum length 4 characters"
    ]
  }),
  methods: {
    ...mapActions("accounts", ["register"]),
    resetValidation() {
      this.errors = NO_ERRORS;
      this.$refs.form.resetValidation();
    },
    async submit() {
      this.submitting = true;
      try {
        this.registration = await this.register({
          // name: this.name,
          email: this.email,
          password1: this.password1,
          password2: this.password2
        });
        this.$emit("registered");
        this.submitting = false;
        this.errors = NO_ERRORS;
        this.close();
      } catch (e) {
        this.submitting = false;
        if (e.response && e.response.data) {
          this.errors = e.response.data;
          console.log(this.error);
        } else {
          // Error when backend is not responding?
          // TODO: unified pattern for backend error handling
          console.log(e);
        }
      }
    },
    close() {
      this.$emit("closed");
    }
  }
};
</script>
